var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "handle-box" },
        [
          _c(
            "el-form",
            {
              ref: "queryCondition",
              staticClass: "searchForm",
              attrs: { model: _vm.queryCondition, "label-width": "120px" },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "supplierManage.supplierInvitationCode"
                                    ),
                                    prop: "invitationCode",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "100%" },
                                    attrs: { clearable: "" },
                                    model: {
                                      value: _vm.queryCondition.invitationCode,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryCondition,
                                          "invitationCode",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression:
                                        "queryCondition.invitationCode",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "supplierManage.supplierChinese"
                                    ),
                                    prop: "supplierName",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "100%" },
                                    attrs: { clearable: "" },
                                    model: {
                                      value: _vm.queryCondition.supplierName,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryCondition,
                                          "supplierName",
                                          $$v
                                        )
                                      },
                                      expression: "queryCondition.supplierName",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "supplierManage.supplierEnglish"
                                    ),
                                    prop: "supplierNameEn",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "100%" },
                                    attrs: { clearable: "" },
                                    model: {
                                      value: _vm.queryCondition.supplierNameEn,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryCondition,
                                          "supplierNameEn",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "queryCondition.supplierNameEn",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "supplierManage.supplierAbbreviation"
                                    ),
                                    prop: "supplierNameShort",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "100%" },
                                    attrs: { clearable: "" },
                                    model: {
                                      value:
                                        _vm.queryCondition.supplierNameShort,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryCondition,
                                          "supplierNameShort",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "queryCondition.supplierNameShort",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-collapse-transition",
                    [
                      _vm.isShow
                        ? _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-row",
                                { attrs: { gutter: 20 } },
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "supplierManage.InvitationCodeStatus"
                                            ),
                                            prop: "invitationCodeStatus",
                                          },
                                        },
                                        [
                                          _c("ic-select", {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              clearable: "",
                                              table: "TM_SUPPLIER",
                                              field: "INVITATION_CODE_STATUS",
                                            },
                                            model: {
                                              value:
                                                _vm.queryCondition
                                                  .invitationCodeStatus,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryCondition,
                                                  "invitationCodeStatus",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "queryCondition.invitationCodeStatus",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "supplierManage.auditStatus"
                                            ),
                                            prop: "auditStatus",
                                          },
                                        },
                                        [
                                          _c("ic-select", {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              clearable: "",
                                              table: "TM_SUPPLIER",
                                              field: "AUDIT_STATUS",
                                            },
                                            model: {
                                              value:
                                                _vm.queryCondition.auditStatus,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryCondition,
                                                  "auditStatus",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "queryCondition.auditStatus",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "邀请日期(从)",
                                            prop: "invitationDateBegin",
                                          },
                                        },
                                        [
                                          _c("el-date-picker", {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              type: "date",
                                              "value-format": "yyyy-MM-dd",
                                              placeholder:
                                                _vm.$t("common.selDate"),
                                              "picker-options":
                                                _vm.pickerOptionsStart,
                                            },
                                            model: {
                                              value:
                                                _vm.queryCondition
                                                  .invitationDateBegin,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryCondition,
                                                  "invitationDateBegin",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "queryCondition.invitationDateBegin",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "邀请日期(至)",
                                            prop: "invitationDateEnd",
                                          },
                                        },
                                        [
                                          _c("el-date-picker", {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              type: "date",
                                              "value-format": "yyyy-MM-dd",
                                              placeholder:
                                                _vm.$t("common.selDate"),
                                              "picker-options":
                                                _vm.pickerOptionsEnd,
                                            },
                                            model: {
                                              value:
                                                _vm.queryCondition
                                                  .invitationDateEnd,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryCondition,
                                                  "invitationDateEnd",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "queryCondition.invitationDateEnd",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { type: "flex", justify: "center", align: "middle" } },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.queryData(1)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.search")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.restQueryForm },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.reset")))]
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "arrowDown",
                      on: {
                        click: function ($event) {
                          _vm.isShow = !_vm.isShow
                        },
                      },
                    },
                    [
                      _vm._v(_vm._s(_vm.isShow ? "收缩" : "展开")),
                      _c("i", {
                        class: _vm.isShow
                          ? "el-icon-arrow-up iconBtn"
                          : "el-icon-arrow-down iconBtn",
                      }),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "action-btn-row" },
        [
          _vm.isShowFunc && _vm.isEmplFlag
            ? _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.SavePotentialSupplier,
                      expression: "SavePotentialSupplier",
                    },
                  ],
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.addsupplierCode(-99999)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.newBuilt")))]
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-table",
        {
          ref: "tableList",
          attrs: {
            data: _vm.tableList,
            border: "",
            "highlight-current-row": "",
            "max-height": "420",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              "min-width": "100",
              "show-overflow-tooltip": "",
              prop: "no",
              label: _vm.$t("supplierManage.supplierInvitationCode"),
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "a-link",
                        on: {
                          click: function ($event) {
                            return _vm.toDetail(scope.row)
                          },
                        },
                      },
                      [_vm._v(_vm._s(scope.row.invitationCode))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              "min-width": "150",
              "show-overflow-tooltip": "",
              prop: "supplierName",
              label: _vm.$t("supplierManage.supplierChinese"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              "min-width": "150",
              "show-overflow-tooltip": "",
              prop: "supplierNameEn",
              label: _vm.$t("supplierManage.supplierEnglish"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              "min-width": "100",
              "show-overflow-tooltip": "",
              prop: "supplierNameShort",
              label: _vm.$t("supplierManage.supplierAbbreviation"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              "min-width": "100",
              "show-overflow-tooltip": "",
              prop: "groupType",
              label: _vm.$t("visitPlan.Type"),
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      _vm._s(
                        _vm._f("ic")(
                          scope.row.groupType,
                          "TM_SUPPLIER",
                          "GROUP_TYPE"
                        )
                      )
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              "min-width": "80",
              "show-overflow-tooltip": "",
              prop: "linkman",
              label: _vm.$t("settlementUnit.contacts"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              "min-width": "80",
              "show-overflow-tooltip": "",
              prop: "telephoneNo",
              label: _vm.$t("common.contactNumber"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              "min-width": "120",
              "show-overflow-tooltip": "",
              prop: "emailAddress",
              label: _vm.$t("sys.userList.email"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              "min-width": "80",
              "show-overflow-tooltip": "",
              prop: "invitationCodeStatusI18n",
              label: _vm.$t("supplierManage.InvitationCodeStatus"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              "min-width": "80",
              "show-overflow-tooltip": "",
              prop: "auditStatusI18n",
              label: _vm.$t("supplierManage.auditStatus"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              "min-width": "100",
              "show-overflow-tooltip": "",
              prop: "description",
              label: _vm.$t("common.remarks"),
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pagination" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.queryCondition.pageNum,
              "page-sizes": _vm.pageSizeList,
              "page-size": _vm.queryCondition.pageSize,
              layout: _vm.pageLayout,
              total: _vm.totalCount,
            },
            on: {
              "size-change": _vm.pageSizeChange,
              "current-change": _vm.pageNumberChange,
            },
          }),
        ],
        1
      ),
      _vm.IsSupplierCodeDialog
        ? _c(
            "el-dialog",
            {
              staticClass: "supplierCodeDialog",
              attrs: { visible: _vm.supplierCodeDialog, width: "40%" },
              on: {
                "update:visible": function ($event) {
                  _vm.supplierCodeDialog = $event
                },
              },
            },
            [
              _c(
                "el-form",
                {
                  ref: "addsupplierCodeRef",
                  attrs: {
                    model: _vm.addsupplierCodeForm,
                    rules: _vm.addsupplierCodeRules,
                    "label-width": "120px",
                  },
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("supplierManage.creater"),
                                prop: "createBy",
                              },
                            },
                            [
                              _c("el-input", {
                                staticClass: "handle-input",
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.addsupplierCodeForm.createBy,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.addsupplierCodeForm,
                                      "createBy",
                                      $$v
                                    )
                                  },
                                  expression: "addsupplierCodeForm.createBy",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("supplierManage.creationDate"),
                                prop: "creationDate",
                              },
                            },
                            [
                              _c("el-input", {
                                staticClass: "handle-input",
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.addsupplierCodeForm.creationDate,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.addsupplierCodeForm,
                                      "creationDate",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "addsupplierCodeForm.creationDate",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("supplierManage.supplierType"),
                            prop: "groupType",
                          },
                        },
                        [
                          _c("ic-select", {
                            attrs: {
                              clearable: "",
                              table: "TM_SUPPLIER",
                              field: "GROUP_TYPE",
                              excludes: ["CARRIER"],
                            },
                            model: {
                              value: _vm.addsupplierCodeForm.groupType,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.addsupplierCodeForm,
                                  "groupType",
                                  $$v
                                )
                              },
                              expression: "addsupplierCodeForm.groupType",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("supplierManage.DomesticOrforeign"),
                            prop: "homeOrAbroad",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.addsupplierCodeForm.homeOrAbroad,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.addsupplierCodeForm,
                                    "homeOrAbroad",
                                    $$v
                                  )
                                },
                                expression: "addsupplierCodeForm.homeOrAbroad",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "IN" } }, [
                                _vm._v(
                                  _vm._s(_vm.$t("supplierManage.domestic"))
                                ),
                              ]),
                              _c("el-radio", { attrs: { label: "OUT" } }, [
                                _vm._v(_vm._s(_vm.$t("supplierManage.abroad"))),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("supplierManage.supplierChinese"),
                            prop: "supplierName",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { clearable: "" },
                            model: {
                              value: _vm.addsupplierCodeForm.supplierName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.addsupplierCodeForm,
                                  "supplierName",
                                  $$v
                                )
                              },
                              expression: "addsupplierCodeForm.supplierName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("supplierManage.supplierEnglish"),
                            prop: "supplierNameEn",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { clearable: "" },
                            model: {
                              value: _vm.addsupplierCodeForm.supplierNameEn,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.addsupplierCodeForm,
                                  "supplierNameEn",
                                  $$v
                                )
                              },
                              expression: "addsupplierCodeForm.supplierNameEn",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "supplierManage.supplierAbbreviation"
                            ),
                            prop: "supplierNameShort",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { clearable: "" },
                            model: {
                              value: _vm.addsupplierCodeForm.supplierNameShort,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.addsupplierCodeForm,
                                  "supplierNameShort",
                                  $$v
                                )
                              },
                              expression:
                                "addsupplierCodeForm.supplierNameShort",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("supplierManage.expiryDate"),
                            prop: "invitationCodeEndDate",
                          },
                        },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              "value-format": "yyyy-MM-dd",
                              type: "date",
                              placeholder: _vm.$t("common.selDate"),
                              "picker-options": _vm.pickerOptions,
                            },
                            model: {
                              value:
                                _vm.addsupplierCodeForm.invitationCodeEndDate,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.addsupplierCodeForm,
                                  "invitationCodeEndDate",
                                  $$v
                                )
                              },
                              expression:
                                "addsupplierCodeForm.invitationCodeEndDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    _vm._l(
                      _vm.addsupplierCodeForm.emailAddress,
                      function (email, index) {
                        return _c(
                          "el-form-item",
                          {
                            key: email.key,
                            staticClass: "email",
                            attrs: {
                              label: _vm.$t("sys.userList.email"),
                              prop: "emailAddress." + index + ".value",
                              rules: _vm.addsupplierCodeRules.emailAddress,
                            },
                          },
                          [
                            _c("el-input", {
                              model: {
                                value: email.value,
                                callback: function ($$v) {
                                  _vm.$set(email, "value", $$v)
                                },
                                expression: "email.value",
                              },
                            }),
                            index == 0
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini" },
                                    on: { click: _vm.addEmail },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("common.add")))]
                                )
                              : _vm._e(),
                            index != 0
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini" },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.removeEmail(email)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("common.del")))]
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      }
                    ),
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer", align: "center" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.supplierCodeDialog = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.close")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.saveSupplier },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.submit")))]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }